module.exports = __webpack_public_path__ + "static/media/no_data_icon.cadb3346.svg";